import React from 'react';
import { View, Text, ViewStyle, TextStyle } from 'react-native';
import { useTheme } from '../context/themeContext';

interface ThumbProps {
  emoji?: string;
  size?: number;
  style?: ViewStyle;
}

export default function Thumb({ emoji, size = 36, style }: ThumbProps) {
  const { theme } = useTheme();
  const { colors, radii } = theme;

  const containerStyle: ViewStyle = {
    width: size,
    height: size,
    borderRadius: radii.r2,
    backgroundColor: colors.paper3,
    borderWidth: 1,
    borderColor: colors.line,
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    overflow: 'hidden',
  };

  const emojiStyle: TextStyle = {
    fontSize: size * 0.5,
    lineHeight: size * 0.6,
    includeFontPadding: false,
    textAlign: 'center',
  };

  return (
    <View style={[containerStyle, style]}>
      <Text style={emojiStyle}>{emoji || '📦'}</Text>
    </View>
  );
}
